import { cn } from "@/lib/utils";

/**
 * Heartstream brand mark — a heart outline ringed by 12 radiating "pulse" rays.
 * Strokes use currentColor, so wrap it in a text color (brand magenta by default).
 */
export function BrandMark({ className }) {
  return (
    <svg
      viewBox="0 0 128 128"
      fill="none"
      role="img"
      aria-label="Heartstream"
      className={cn("text-primary", className)}
    >
      <g stroke="currentColor" strokeWidth="5" strokeLinecap="round">
        <line x1="64" y1="27" x2="64" y2="14" />
        <line x1="82.5" y1="32" x2="86.5" y2="25" />
        <line x1="96" y1="45.5" x2="107.3" y2="39" />
        <line x1="101" y1="64" x2="109" y2="64" />
        <line x1="96" y1="82.5" x2="107.3" y2="89" />
        <line x1="82.5" y1="96" x2="86.5" y2="103" />
        <line x1="64" y1="101" x2="64" y2="114" />
        <line x1="45.5" y1="96" x2="41.5" y2="103" />
        <line x1="32" y1="82.5" x2="20.7" y2="89" />
        <line x1="27" y1="64" x2="19" y2="64" />
        <line x1="32" y1="45.5" x2="20.7" y2="39" />
        <line x1="45.5" y1="32" x2="41.5" y2="25" />
      </g>
      <g transform="translate(34,35.38) scale(2.5)">
        <path
          d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
}

/** Brand mark + "heartstream" wordmark (the "stream" half in brand magenta). */
export function Logo({ className, markClassName }) {
  return (
    <span className={cn("inline-flex items-center gap-2", className)}>
      <BrandMark className={cn("h-10 w-10 shrink-0", markClassName)} />
      <span className="text-[17px] font-extrabold leading-none tracking-[-0.02em]">
        <span className="text-foreground">heart</span>
        <span className="text-primary">stream</span>
      </span>
    </span>
  );
}

export default Logo;
